/**
 *
 * @param {UpcLatchkeyParserParam} param
 * @returns {void}
 */
export default function UpcLatchkeyParser({ upcMap, colorMap, sizeMap, useColorArray }) {
  const noColors = colorMap.colorArray.filter((color) => color.name === 'No Color');
  sizeMap.sizeArray.forEach((size) => {
    const colorId = Object.keys(size?.colorToSizes)[0];
    const primaryUpcMap = `${colorId}_${size.id}`;
    const primaryUpc = upcMap[primaryUpcMap];
    if (primaryUpc) {
      const colorSource = useColorArray ? colorMap.colorArray : noColors;
      colorSource.forEach((color) => {
        const upcStr = `${color.id}_${size.id}`;
        if (!upcMap[upcStr]) {
          upcMap[upcStr] = primaryUpc;
        }
      });
    }
  });
}
